var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1447_229423",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24.6621,
    width: 24,
    height: 24,
    transform: "rotate(90 24.6621 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1447_229423)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6622 9.42546C10.6622 8.97546 10.8664 8.66296 11.2747 8.48796C11.683 8.31296 12.0455 8.3838 12.3622 8.70046L14.9622 11.3005C15.0622 11.4005 15.1372 11.5088 15.1872 11.6255C15.2372 11.7421 15.2622 11.8671 15.2622 12.0005C15.2622 12.1338 15.2372 12.2588 15.1872 12.3755C15.1372 12.4921 15.0622 12.6005 14.9622 12.7005L12.3622 15.3005C12.0455 15.6171 11.683 15.688 11.2747 15.513C10.8664 15.338 10.6622 15.0255 10.6622 14.5755V9.42546Z",
    fill: "#2EBF93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.1ba30bc50436a655532b122790e57e44.svg";
export { ForwardRef as ReactComponent };